import UniCard from './UniCard';
import CTA from './shared/CardCTA';
import Image from './shared/CardImage';
import PaymentDetails from './shared/CardPaymentDetails';
import Pricing from './shared/CardPricing';
import SubTitle from './shared/CardSubTitle';
import Title from './shared/CardTitle';
import TitleWrapper from './shared/CardTitleWrapper';
import DriveRange from './shared/CardDriveRange';
import StatusBadge from './shared/CardStatusBadge';
UniCard.Image = Image;
UniCard.Title = Title;
UniCard.TitleWrapper = TitleWrapper;
UniCard.Pricing = Pricing;
UniCard.SubTitle = SubTitle;
UniCard.PaymentDetails = PaymentDetails;
UniCard.CTA = CTA;
UniCard.DriveRange = DriveRange;
UniCard.StatusBadge = StatusBadge;
export default UniCard;
